import React from 'react'
import PropTypes from 'prop-types'
import 'parsleyjs'
import { createLoader, removeLoader } from '../../loader'
import createModal from './../../modal/createModal'
import createConfirm from '../../modal/createConfirm'
import Form from './Form'
import { deleteServiceAppointment, getUserData } from '../../services/api/serviceAppointment'
import { resolveDefaultService, resolveRealizedForId } from './helpers'
import { GET, POST, PUT } from '../../services/api'
import { ajax } from '../../ajax'
import { _ } from '../../gettext'

export default class ServiceAppointmentModal extends React.Component {
  static propTypes = {
    reservation: PropTypes.object,
    ticketId: PropTypes.string,
    defaultFrom: PropTypes.string,
    defaultTo: PropTypes.string,
    defaultEquipment: PropTypes.array,
    defaultFormService: PropTypes.string,
    defaultRealisedFor: PropTypes.object,
    defaultProject: PropTypes.object,
    defaultResearchGroup: PropTypes.object,
    modal: PropTypes.object,
    copy: PropTypes.bool,
    onAfterSave: PropTypes.func,
    onAfterDelete: PropTypes.func,
    onCopy: PropTypes.func
  }

  static defaultProps = {
    copy: false
  }

  formRef = React.createRef()

  /** @type {Form} */
  parsley = null

  state = {
    favourites: {},
    equipment: {},
    researchGroups: {},
    projects: {},
    contacts: {},
    services: {},
    materials: {},
    errors: [],
    canEditRealisedFor: true,
    canEditPrivateDescription: false,
    isLoggedUserInRoleAdmin: false,
    priceTime: 0.0,
    priceReservation: 0.0,
    priceMaterial: 0.0,
    servicesLoading: false,
    materialsLoading: false,
    form: {
      from: '',
      to: '',
      equipment: [],
      researchGroup: '',
      statusCode: '',
      project: '',
      description: '',
      new_service_ticket: '',
      privateDescription: '',
      timeRequirement: '',
      psa_additionalrequestcapacity: 1,
      additionalContacts: [],
      service: '',
      materials: [],
      createRealisedFor: false,
      realisedFor: '',
      realisedForFirstname: '',
      realisedForLastname: '',
      realisedForEmail: '',
      realisedForInstitution: ''
    }
  }

  componentDidMount () {
    this.parsley = $(this.formRef.current).parsley()

    this.handleLoadUserData(resolveRealizedForId(this.props), this.props.ticketId).finally(() => {
      this.handleSetFormDefaults()
      this.handleCanEditPrivateDescription()
      this.handleLoadServices()
      this.handleLoadMaterials()
      this.handleLoadPrices()
      removeLoader()
    })
  }

  handleChange = (key, value) => {
    let statusCode = this.state.form.statusCode
    let service = this.state.form.service

    // Load realised for contacts project, research group and favourites
    if (key === 'realisedFor') {
      createLoader()
      this.handleLoadUserData(value, this.props.ticketId).finally(removeLoader)
    }

    // Load service ticket project, research group and favourites
    if (key === 'new_service_ticket') {
      createLoader()
      this.handleLoadUserData(this.state.form.realisedFor, value).finally(() => {
        removeLoader()
        // Set status code defined by service ticket equipment default state
        const serviceTicketEquipment = this.state.equipment[this.state.form.equipment[0]]
        this.setState({
          form: {
            ...this.state.form,
            statusCode: undefined !== serviceTicketEquipment && serviceTicketEquipment.ge_defaultrequeststatecode
              ? (serviceTicketEquipment.ge_defaultrequeststatecode === 1 ? 1 : 4) : ''
          }
        })
      })
    }

    if (key === 'materials') {
      this.handleCalculateMaterialsPrice(value)
    }

    if (key === 'equipment') {
      if (value.length > 0) {
        // Load services by equipment
        this.handleLoadServices(value[0])

        // Load materials by equipment
        this.handleLoadMaterials(value[0])

        // Set service defined by equipment default form service
        service = resolveDefaultService(value[0], this.state.equipment, this.props)

        // Set status code defined by equipment default state
        statusCode = undefined !== this.state.equipment[value[0]] && this.state.equipment[value[0]].ge_defaultrequeststatecode
          ? (this.state.equipment[value[0]].ge_defaultrequeststatecode === 1 ? 1 : 4) : ''

        // Check if user is owner of all equipment, if not, he cannot edit realized for
        ajax({
          method: GET,
          url: '/api-deprecated/system-user/is-equipment-owner/?equipmentIds=' + value.join(','),
        }).then(({ data }) => {
          this.setState({ canEditRealisedFor: data.data })
        })
      }
    }

    this.setState({
      form: {
        ...this.state.form,
        statusCode: statusCode,
        service: service,
        [key]: value
      }
    })

    // Reload prices
    if (['from', 'to', 'equipment', 'project', 'service', 'realisedFor'].indexOf(key) !== -1) {
      this.handleLoadPrices()
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()

    if (this.parsley.isValid() === false) {
      this.setState({
        errors: [_('Zadejte prosím všechny povinná pole.')]
      })
    } else {
      this.setState({
        errors: []
      })

      createLoader()
      ajax({
        method: this.props.reservation !== null && this.props.copy === false ? PUT : POST,
        url: '/api-deprecated/service-appointment/' + (
          this.props.reservation !== null && this.props.copy === false ? this.props.reservation.model.id + '/' : ''
        ),
        data: this.state.form
      }).then(({ data }) => {
        if (this.props.onAfterSave) {
          this.props.onAfterSave(this.props.modal, data.data)
        }

        if (data.messages && data.messages.length > 0) {
          removeLoader()
          createModal(_('Upozornění'), data.messages.join('<br />')).show()
        }
      })
    }
  }

  handleDelete = (e) => {
    e.preventDefault()

    createConfirm(
      _('Opravdu chcete rezervaci vymazat?'),
      () => {
        createLoader()
        deleteServiceAppointment(this.props.reservation.model.id).then(({ data }) => {
          if (this.props.onAfterDelete) {
            this.props.onAfterDelete(this.props.modal, data)
          }

          if (data.messages?.length > 0) {
            removeLoader()
            createModal(_('Upozornění'), data.messages.join('<br />')).show()
          }
        })
      }
    ).show()
  }

  handleLoadUserData = (realizedForId, ticketId) => {
    const { reservation, defaultResearchGroup, defaultProject, defaultRealisedFor } = this.props

    return getUserData(
      realizedForId,
      ticketId,
      reservation ? reservation.model.ge_res_groupid : (defaultResearchGroup || {}),
      reservation ? reservation.model.psa_projectid : (defaultProject || {}),
      reservation ? reservation.model.ge_realised_for_contactid : (defaultRealisedFor || {})
    ).then(({ data }) => {
      this.setState({
        isLoggedUserInRoleAdmin: data.isLoggedUserInRoleAdmin,
        favourites: data.favourites,
        equipment: data.equipment,
        researchGroups: data.researchGroups,
        projects: data.projects,
        contacts: Array.isArray(data.contacts) ? {} : data.contacts,
        form: {
          ...this.state.form,
          project: data.form.project ? data.form.project : this.state.form.project,
          researchGroup: data.form.researchGroup ? data.form.researchGroup : this.state.form.researchGroup,
          equipment: data.form.equipment ? data.form.equipment : this.state.form.equipment,
          timeRequirement: data.form.timeRequirement,
          realisedFor: data.form.realisedFor ? data.form.realisedFor : this.state.form.realisedFor,
        }
      })
    })
  }

  handleLoadPrices = () => {
    ajax({
      url: '/api-deprecated/service-appointment/prices/',
      method: GET,
      params: {
        from: this.state.form.from,
        to: this.state.form.to,
        equipmentId: this.state.form.equipment && this.state.form.equipment.length > 0
          ? this.state.form.equipment[0] : null,
        fsId: this.state.form.service,
        projectId: this.state.form.project,
        realisedForContactId: this.state.form.realisedFor
      }
    }).then(({ data }) => {
      this.setState({
        priceTime: data.priceTime,
        priceReservation: data.priceReservation
      })
    })
  }

  handleCanEditPrivateDescription = () => {
    ajax({
      url: '/api-deprecated/system-user/can-edit-service-appointment-private-description/',
      method: POST,
      data: {
        reservation: this.props.reservation ? this.props.reservation.model : null,
        form: this.state.form
      }
    }).then(({ data }) => {
      this.setState({ canEditPrivateDescription: data })
    })
  }

  handleLoadServices = (equipmentId = null) => {
    const guid = equipmentId || (this.state.form.equipment && this.state.form.equipment.length > 0 ? this.state.form.equipment[0] : null)

    if (guid === null) {
      return
    }

    this.setState({
      servicesLoading: true
    })

    return ajax({
      method: GET,
      url: '/api-deprecated/form-service/?equipmentId=' + guid
    }).then(({ data }) => {
      this.setState({
        services: Object.keys(data.pairs).length > 0 ? data.pairs : {},
        servicesLoading: false
      })
    })
  }

  handleCalculateMaterialsPrice = (materialIds = null) => {
    const materials = materialIds || this.state.form.materials

    let priceMaterial = 0.0

    materials.map((key) => {
      if (this.state.materials[key].cenarezervace !== -1) {
        priceMaterial += this.state.materials[key].cenarezervace
      }
    })

    this.setState({
      priceMaterial: priceMaterial
    })
  }

  handleLoadMaterials = (equipmentId = null) => {
    const guid = equipmentId || (this.state.form.equipment && this.state.form.equipment.length > 0 ? this.state.form.equipment[0] : null)

    if (guid === null) {
      return
    }

    this.setState({
      materialsLoading: true
    })

    return ajax({
      method: GET,
      url: '/api-deprecated/equipment/' + guid + '/?withoutMaterials=0'
    }).then(({ data }) => {
      const materials = {}

      if (undefined === data.data.materials) {
        this.setState({
          materialsLoading: false
        })
        return
      }

      data.data.materials.map((material) => {
        materials[material.id] = material
      })

      this.setState({
        materials: materials,
        materialsLoading: false
      })

      this.handleCalculateMaterialsPrice()
    })
  }

  handleSetFormDefaults = () => {
    if (this.props.reservation) {
      this.setState({
        form: {
          ...this.state.form,
          ...this.props.reservation.formData
        }
      })
    } else {
      const defaultEquipment = this.props.defaultEquipment || this.state.form.equipment

      this.setState({
        form: {
          ...this.state.form,
          from: this.props.defaultFrom,
          to: this.props.defaultTo,
          equipment: defaultEquipment,
          new_service_ticket: this.props.ticketId,
          statusCode: defaultEquipment && undefined !== this.state.equipment[defaultEquipment[0]] &&
            this.state.equipment[defaultEquipment[0]].ge_defaultrequeststatecode
            ? (this.state.equipment[defaultEquipment[0]].ge_defaultrequeststatecode === 1 ? 1 : 4) : '',
          service: resolveDefaultService(this.props.defaultEquipment ? this.props.defaultEquipment[0] : null, this.state.equipment, this.props),
          researchGroup: this.props.defaultResearchGroup ? this.props.defaultResearchGroup.id : this.state.form.researchGroup,
          project: this.props.defaultProject ? this.props.defaultProject.id : this.state.form.project,
          realisedFor: this.props.defaultRealisedFor ? this.props.defaultRealisedFor.id : this.state.form.realisedFor
        }
      })
    }
  }

  handleToggleRealisedFor = (e) => {
    e.preventDefault()

    if (this.state.createRealisedFor === true) {
      $(e.target).text(_('Nový kontakt'))
      $('.realised-for-new').addClass('d-none')
      $('.realised-for-existing').removeClass('d-none')
    } else {
      $(e.target).text(_('Použít existující kontakt'))
      $('.realised-for-existing').addClass('d-none')
      $('.realised-for-new').removeClass('d-none')
    }

    this.setState({
      createRealisedFor: !this.state.createRealisedFor
    })
  }

  handleToggleCard = (e, className) => {
    e.preventDefault()

    const $body = $(className)
    const $icon = $('.card-header i', $body.parent())

    if ($body.css('display') === 'none') {
      $body.slideDown()
      $icon.removeClass('fa-angle-double-down').addClass('fa-angle-double-up')
    } else {
      $body.slideUp()
      $icon.removeClass('fa-angle-double-up').addClass('fa-angle-double-down')
    }
  }

  handleCopyReservation = (e) => {
    e.preventDefault()
    this.props.onCopy(this.props.modal)
  }

  handleApproveReservation = (e) => {
    e.preventDefault()
    createLoader()
    ajax({ url: `?do=approveReservation&reservationId=${this.props.reservation.model.id}` }).then(() => {
      this.props.onAfterSave(this.props.modal)
    })
  }

  render () {
    return (
      <form onSubmit={this.handleSubmit} ref={this.formRef}>
        <div className="modal-body">
          <Form
            reservation={this.props.reservation}
            ticketId={this.props.ticketId}
            favourites={this.state.favourites}
            researchGroups={this.state.researchGroups}
            projects={this.state.projects}
            contacts={this.state.contacts}
            services={this.state.services}
            materials={this.state.materials}
            errors={this.state.errors}
            priceTime={this.state.priceTime}
            priceMaterial={this.state.priceMaterial}
            priceReservation={this.state.priceReservation}
            isLoggedUserInRoleAdmin={this.state.isLoggedUserInRoleAdmin}
            defaultRealisedFor={this.props.defaultRealisedFor}
            canEditPrivateDescription={this.state.canEditPrivateDescription}
            form={this.state.form}
            onChange={this.handleChange}
            handleToggleRealisedFor={this.handleToggleRealisedFor}
            handleToggleCard={this.handleToggleCard}
            servicesLoading={this.state.servicesLoading}
            materialsLoading={this.state.materialsLoading}
          />
        </div>
        <div className="modal-footer">
          <button type="submit" className="btn btn-success">
            {_('Uložit')}
          </button>
          <button onClick={this.handleDelete}
            className={'btn btn-danger' + (this.props.reservation === null || this.props.copy === true ? ' d-none' : '')}>
            {_('Smazat')}
          </button>
          <button onClick={this.handleCopyReservation}
            className={'btn btn-secondary' + (this.props.reservation === null || this.props.copy === true ? ' d-none' : '')}>
            {_('Kopírovat')}
          </button>
          <button onClick={this.handleApproveReservation}
            className={'btn btn-secondary' + (this.props.reservation === null || this.props.copy === true || this.props.reservation.model.statuscode !== 1 ? ' d-none' : '')}>
            {_('Schválit')}
          </button>
          <a href="#" className="btn btn-secondary modal-close">
            {_('Zavřít')}
          </a>
        </div>
      </form>
    )
  }
}
